import { createAppBasePath } from '@beautyburst/tokens';

/**
 * Admin route patterns stay independent of deployment location. Apply this
 * adapter at browser boundaries only.
 */
/**
 * Relative-base browser bundles live below `assets/`. Passing that directory
 * lets the shared base-path helper recover the application directory rather
 * than retaining `/assets/` as part of every route and asset URL.
 */
export function createAdminBasePath(
  viteBase = import.meta.env.BASE_URL,
  moduleUrl = import.meta.url,
) {
  return createAppBasePath(viteBase, new URL('.', moduleUrl).toString());
}

export const adminBasePath = createAdminBasePath();
export const adminHref = (path: string): string => adminBasePath.prefix(path);
export const adminAsset = (path: string): string => adminBasePath.asset(path);
